export enum SupportedProtocols {
  PANCAKESWAP = 'pancakeswap',
  CHADSWAP = 'chadswap',
}

export const PROTOCOL_MAPPING = {
  [SupportedProtocols.PANCAKESWAP]: {
    name: 'PancakeSwap',
    id: [SupportedProtocols.PANCAKESWAP],
    interest: 4,
    INIT_CODE_HASH: '0x6ce8eb472fa82df5469c6ab6d485f17c3ad13c8cd7af59b3d4a8026c5ce0f7e2',
    addLiquidityRoute:
      'https://pancakeswap.finance/liquidity/select/56/v3/BNB/0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82?chain=bsc&selectId=bsc&selectId=infinity&selectId=BNB&selectId=0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82',
  },
  [SupportedProtocols.CHADSWAP]: {
    name: 'ChadSwap',
    id: [SupportedProtocols.CHADSWAP],
    interest: 4,
    INIT_CODE_HASH: '0xf71a451f030b45b949f1bf44bd386cafcbaf41abe298bcdfbc8fd8315d6dfcec',
    addLiquidityRoute: '/#/add/',
  },
}
